import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useCart } from "./CartContext";

const NAV_LINKS = [
  { path: "/home", label: "Home" },
  { path: "/ContactUs", label: "Contact Us" },
  { path: "/AboutUs", label: "About Us" },
  { path: "/Privacy", label: "Privacy & Policy" },
  { path: "/Requestcall", label: "Request A Call" },
];

const HIDE_CART_PAGES = [
  "/home",
  "/AboutUs",
  "/ContactUs",
  "/Requestcall",
  "/",
  "/Cart",
  "/Privacy",
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { cart } = useCart();
  const location = useLocation();

  const toggleNavbar = () => setIsOpen((prev) => !prev);
  const closeNavbar = () => setIsOpen(false);

  // Prevent background scrolling on mobile when the overlay menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const hideCart = HIDE_CART_PAGES.includes(location.pathname);

  const CartButton = ({ className = "" }) => (
    <Link
      to="/Cart"
      className={`btn btn-link text-dark position-relative p-2 d-inline-flex align-items-center ${className}`}
      onClick={closeNavbar}
      style={{ transition: "transform 0.2s ease" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
      >
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <path d="M16 10a4 4 0 0 1-8 0"></path>
      </svg>
      {cart.length > 0 && (
        <span
          className="position-absolute badge rounded-pill bg-danger fw-bold d-flex align-items-center justify-content-center"
          style={{
            fontSize: "0.65rem",
            top: "2px",
            right: "2px",
            width: "18px",
            height: "18px",
          }}
        >
          {cart.length}
        </span>
      )}
    </Link>
  );

  return (
    <nav className="navbar navbar-expand-lg fixed-top shadow-sm py-2 py-lg-3 glass-nav">
      <div className="container px-3 px-md-4">
        {/* Logo */}
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/home"
          onClick={closeNavbar}
        >
          <img
            src="assets/assets/img/FLAWSKIN-LOGO.png"
            alt="Flawskin Logo"
            style={{ height: "38px", width: "auto" }}
          />
        </Link>

        {/* Mobile Actions Container */}
        <div className="d-flex align-items-center order-lg-last gap-2">
          {!hideCart && <CartButton className="d-lg-none" />}

          {/* Premium Animated Hamburger Button */}
          <button
            className={`custom-toggler d-lg-none ${isOpen ? "open" : ""}`}
            type="button"
            onClick={toggleNavbar}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Menu Navigation Items links container */}
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          {/* Mobile-Only Search Layout (Placed at top of mobile dropdown) */}
          <div className="d-lg-none mb-4">
            <form role="search" onSubmit={(e) => e.preventDefault()}>
              <input
                className="form-control search-input-premium w-100"
                type="search"
                placeholder="Search treatments & products..."
                aria-label="Search"
              />
            </form>
          </div>

          {/* Links list navigation wrapper */}
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-3 gap-lg-4">
            {NAV_LINKS.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <li className="nav-item mobile-nav-item" key={link.path}>
                  <Link
                    className={`nav-link fw-semibold fs-5 fs-lg-6 py-2 py-lg-1 px-0 ${
                      isActive
                        ? "text-primary border-bottom border-primary border-2 d-inline-block d-lg-block"
                        : "text-secondary"
                    }`}
                    to={link.path}
                    onClick={closeNavbar}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* Desktop Only Search & Actions wrapper */}
          <div className="d-none d-lg-flex align-items-center gap-3">
            <form role="search" onSubmit={(e) => e.preventDefault()}>
              <input
                className="form-control search-input-premium"
                type="search"
                placeholder="Search..."
                aria-label="Search"
              />
            </form>
            {!hideCart && <CartButton className="ms-2" />}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
